import React, { useState } from "react";
import { FaEdit, FaTrash, FaCopy, FaPlus } from "react-icons/fa";
import { useDeleteItem } from "../../_helper/actions/mutation/items";
import { toast } from "react-toastify";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import CuSpinner from "../../common_component/component/CuSpinner";

const ManageQuestionnaires = ({
  templates,
  onTemplateSelect,
  currentTemplate,
  onSaveCurrentTemplate,
  onDiscardCurrentTemplate,
  clinic_id,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationType, setConfirmationType] = useState(null); // "switch" | "copy" | "delete"
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const deleteMutation = useDeleteItem(ApiEndPoint.CONSULTATION);

  const confirmAction = () => {
    if (confirmationType === "copy") {
      const newTemplate = {
        ...selectedTemplate,
        template_id: Date.now().toString(),
        template_name: `${selectedTemplate.template_name} (Copy)`,
      };
      onTemplateSelect(newTemplate);
    } else if (confirmationType === "delete") {
      deleteMutation.mutate(
        {
          data: {
            action: "delPreconsultationTemplete",
            id: selectedTemplate?.id,
            clinic_id: clinic_id,
          },
        },
        {
          onSuccess: () => {
            toast.success("Template deleted successfully");
            setShowConfirmation(false);
          },
          onError: () => {
            toast.error("Failed to delete template");
          },
        }
      );
      // onTemplateSelect(updatedTemplates);
    } else if (confirmationType === "switch") {
      onTemplateSelect(selectedTemplate);
    }
    setShowConfirmation(false);
    setSelectedTemplate(null);
  };

  const handleSwitchTemplate = (template) => {
    if (currentTemplate?.template_name && currentTemplate !== template) {
      setConfirmationType("switch");
      setSelectedTemplate(template);
      setShowConfirmation(true);
    } else {
      onTemplateSelect(template);
    }
  };

  const handleCreateNew = () => {
    const newTemplate = {
      template_id: Date.now().toString(),
      template_name: "New Template",
      categories: [],
    };
    if (currentTemplate?.template_name) {
      setConfirmationType("switch");
      setSelectedTemplate(newTemplate);
      setShowConfirmation(true);
    } else {
      onTemplateSelect(newTemplate);
    }
  };

  const handleAction = (actionType, template) => {
    setConfirmationType(actionType);
    setSelectedTemplate(template);
    setShowConfirmation(true);
  };

  const handleSaveOrDiscard = (action) => {
    if (action === "save") {
      onSaveCurrentTemplate();
    } else if (action === "discard") {
      onDiscardCurrentTemplate();
    }
    confirmAction();
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Manage Questionnaires</h2>
      <ul className="space-y-2">
        {templates?.map((template) => (
          <li
            key={template?.template_id}
            className="flex justify-between items-center p-2 border rounded hover:bg-gray-100 cursor-pointer"
          >
            <span>{template?.template_name}</span>
            <div className="flex gap-2">
              <button
                onClick={() => handleSwitchTemplate(template)}
                className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 flex items-center gap-2"
              >
                <FaEdit />
              </button>
              <button
                onClick={() => handleAction("copy", template)}
                className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600 flex items-center gap-2"
              >
                <FaCopy />
              </button>
              <button
                onClick={() => handleAction("delete", template)}
                className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 flex items-center gap-2"
              >
                <FaTrash />
              </button>
            </div>
          </li>
        ))}
      </ul>
      <button
        onClick={handleCreateNew}
        className="mt-4 w-full bg-green-500 text-white py-2 rounded hover:bg-green-600 flex items-center justify-center gap-2"
      >
        <FaPlus /> Create New Template
      </button>

      {/* Confirmation Modal */}
      {showConfirmation && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded p-6 w-1/3 shadow-lg">
            <h3 className="text-lg font-bold mb-4">
              {confirmationType === "copy"
                ? `Do you really want to copy "${selectedTemplate.template_name}"?`
                : confirmationType === "delete"
                  ? `Do you really want to delete "${selectedTemplate.template_name}"?`
                  : `You have unsaved changes in "${currentTemplate.template_name}". Save changes or discard before proceeding?`}
            </h3>
            <div className="flex justify-end gap-4">
              {confirmationType === "switch" && (
                <>
                  <button
                    onClick={() => handleSaveOrDiscard("save")}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                  >
                    Save
                  </button>
                  <button
                    onClick={() => handleSaveOrDiscard("discard")}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                  >
                    Discard
                  </button>
                </>
              )}
              {confirmationType !== "switch" && (
                <button
                  onClick={() => setShowConfirmation(false)}
                  className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                >
                  Cancel
                </button>
              )}
              {confirmationType !== "switch" && (
                <button
                  onClick={confirmAction}
                  className={`${
                    confirmationType === "copy"
                      ? "bg-green-500 hover:bg-green-600"
                      : confirmationType === "delete"
                        ? "bg-red-500 hover:bg-red-600"
                        : ""
                  } text-white px-4 py-2 rounded`}
                >
                  {deleteMutation.isLoading ? <CuSpinner /> : "Confirm"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageQuestionnaires;
